import { useHirerAuth } from '@seek/hirer-auth-react';
import { useAccountContext } from '@seek/hirer-graphql-react';

export const useAccountInfo = () => {
  const { authenticated } = useHirerAuth();

  const { accountContext, error, loading } = useAccountContext({
    skip: !authenticated,
  });

  const advertiser = accountContext?.currentAdvertiser
    ? {
        ...accountContext?.currentAdvertiser,
        isAdministrator:
          accountContext?.currentAdvertiser?.role?.toLowerCase() ===
          'administrator',
        permissionOptions: accountContext?.currentAdvertiser?.permissionOptions,
      }
    : undefined;

  return {
    headerFooterContext: accountContext?.headerFooterContext,
    user: accountContext?.currentUser,
    advertiser,
    error,
    loading,
    authenticated,
  };
};
